/* =============================================================
   TOURNAMENT SELECTORS
============================================================= */

export const selectTournamentsState = (state) =>
  state.admin?.tournaments || {};

/* =============================================================
   DROPDOWN TOURNAMENTS
============================================================= */

export const selectTournamentList = (state) =>
  selectTournamentsState(state).dropdownList || [];

/* =============================================================
   ADMIN TOURNAMENT LIST
============================================================= */

export const selectAdminTournaments = (state) =>
  selectTournamentsState(state).tournaments || [];

export const selectSelectedTournament = (state) =>
  selectTournamentsState(state).selectedTournament || null;

/* =============================================================
   PAGINATION
============================================================= */

export const selectTournamentCurrentPage = (state) =>
  selectTournamentsState(state).currentPage || 1;

export const selectTournamentTotalPages = (state) =>
  selectTournamentsState(state).totalPages || 1;

export const selectTournamentTotal = (state) =>
  selectTournamentsState(state).total || 0;

/* =============================================================
   COMMON
============================================================= */

export const selectTournamentLoading = (state) =>
  selectTournamentsState(state).loading || false;

export const selectTournamentError = (state) =>
  selectTournamentsState(state).error || null;

/* =============================================================
   DROPDOWN HELPERS
============================================================= */
export const selectCategoriesByTournament =
  (tournamentId) => (state) => {
    const tournaments = selectTournamentList(state);

    const tournament = tournaments.find(
      (t) => Number(t.id) === Number(tournamentId)
    );

    return tournament?.tournament_categories || [];
  };
// export const selectCategoriesByTournament =
//   (tournamentId) => (state) => {
//     const tournaments = selectTournamentList(state);

//     const tournament = tournaments.find(
//       (t) => Number(t.id) === Number(tournamentId)
//     );

//     return tournament?.categories || [];
//   };

export const selectTournamentById =
  (tournamentId) => (state) => {
    const tournaments = selectTournamentList(state);

    return (
      tournaments.find(
        (t) => Number(t.id) === Number(tournamentId)
      ) || null
    );
  };

// /* =============================================================
//    🧠 TOURNAMENT SELECTORS
// ============================================================= */

// export const selectTournamentsState = (state) =>
//   state.admin?.tournaments || {};

// export const selectTournamentList = (state) =>
//   selectTournamentsState(state).list || [];

// export const selectTournamentLoading = (state) =>
//   selectTournamentsState(state).loading || false;

// export const selectTournamentError = (state) =>
//   selectTournamentsState(state).error || null;

// /* 🎯 Get categories by tournament ID */
// export const selectCategoriesByTournament = (tournamentId) => (state) => {
//   const tournaments = selectTournamentList(state);
//   const t = tournaments.find((t) => t.id == tournamentId);
//   return t?.categories || [];
// };

// /* 🎯 Get single tournament */
// export const selectTournamentById = (tournamentId) => (state) => {
//   const tournaments = selectTournamentList(state);
//   return tournaments.find((t) => t.id == tournamentId) || null;
// };